import { render, staticRenderFns } from "./MeetOurTeam.vue?vue&type=template&id=bf16b666&"
import script from "./MeetOurTeam.vue?vue&type=script&lang=js&"
export * from "./MeetOurTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports